export const DEFAULT_NAMESPACE = 'common';

// Loaded at startup. Page modules add their own namespace lazily through
// useTranslation('pages/<module>'), backed by public/locales/<lng>/pages/<module>.json.
export const BASE_NAMESPACES = [
  'common',
  'header',
  'auth',
  'validation',
  'components',
  'containers',
  'constants',
  'helpers',
];
